import type { CSSProperties } from "react";

export const s: Record<string, CSSProperties> = {
  msg: { fontSize: 14, color: "var(--color-text-secondary)", padding: 24 },
  card: {
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    padding: 16,
    marginBottom: 20,
  },
  infoRow: { display: "flex", padding: "6px 0", gap: 12 },
  infoLabel: {
    width: 100,
    fontSize: 12,
    color: "var(--color-text-secondary)",
    fontWeight: 500,
  },
  infoValue: { fontSize: 13 },
  badge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 11,
    fontWeight: 600,
  },
  actionGroup: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: 8,
    maxWidth: 560,
  },
  dangerBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-danger)",
    color: "#fff",
  },
  warningBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "#b45309",
    color: "#fff",
  },
  primaryBtn: {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    borderRadius: 6,
    background: "var(--color-primary)",
    color: "#fff",
  },
  deactivatedLabel: {
    fontSize: 13,
    color: "var(--color-text-secondary)",
    fontStyle: "italic",
  },
  tabBar: {
    display: "flex",
    gap: 0,
    borderBottom: "1px solid var(--color-border)",
    marginBottom: 16,
  },
  tab: {
    padding: "10px 16px",
    fontSize: 13,
    fontWeight: 500,
    background: "none",
    color: "var(--color-text-secondary)",
    borderBottom: "2px solid transparent",
  },
  tabActive: {
    color: "var(--color-text)",
    borderBottomColor: "var(--color-primary)",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: 12,
  },
  statCard: {
    display: "flex",
    flexDirection: "column",
    padding: 16,
    border: "1px solid var(--color-border)",
    borderRadius: 8,
  },
  statLabel: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    marginBottom: 4,
  },
  statValue: { fontSize: 18, fontWeight: 600 },
  miniTable: { width: "100%", borderCollapse: "collapse" },
  th: {
    textAlign: "left",
    padding: "8px 12px",
    fontSize: 12,
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    borderBottom: "1px solid var(--color-border)",
  },
  td: {
    padding: "8px 12px",
    fontSize: 13,
    borderBottom: "1px solid var(--color-border)",
  },
  emptyTab: { fontSize: 13, color: "var(--color-text-secondary)", padding: 16 },
  dialog: {
    border: "none",
    borderRadius: 8,
    padding: 0,
    maxWidth: 720,
    width: "min(720px, calc(100vw - 32px))",
    boxShadow: "0 4px 24px rgba(0, 0, 0, 0.12)",
  },
  dialogContent: { padding: 24 },
  dialogTitle: { fontSize: 18, fontWeight: 600, marginBottom: 8 },
  dialogDescription: {
    fontSize: 14,
    color: "var(--color-text-secondary)",
    lineHeight: 1.6,
    marginBottom: 16,
  },
  dialogGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 12,
  },
  dialogField: { display: "flex", flexDirection: "column", gap: 6 },
  dialogLabel: {
    fontSize: 12,
    color: "var(--color-text-secondary)",
    fontWeight: 600,
  },
  dialogInput: {
    padding: "8px 10px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    fontSize: 13,
  },
  dialogTextarea: {
    padding: "8px 10px",
    border: "1px solid var(--color-border)",
    borderRadius: 6,
    fontSize: 13,
    resize: "vertical",
  },
  dialogHint: { fontSize: 12, color: "var(--color-text-secondary)" },
  dialogActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 16,
  },
  cancelBtn: {
    padding: "8px 16px",
    fontSize: 14,
    borderRadius: 6,
    border: "1px solid var(--color-border)",
    background: "var(--color-bg)",
    color: "var(--color-text)",
  },
  confirmDangerBtn: {
    padding: "8px 16px",
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 6,
    border: "none",
    background: "var(--color-danger)",
    color: "#ffffff",
  },
  confirmBtnDisabled: { opacity: 0.4, cursor: "not-allowed" },
};
